import ProductsTextil from "./ProductsTextil";

export default ProductsTextil;